import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import environment from "web/script/modules/environment";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import classnames from "classnames";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import analytics from "web/script/analytics/analytics";
import styles from "./email-signup-banner.css";

interface EmailSignupBannerProps {
    openCustomerCaptureOverlay: (object) => void;
    onClose: () => void;
}

const DESC_KEYS = {
    // Create wishlists of your favourite items
    desc_1: gettextNoop("member_signup_small_banner.wishlist.description"),
    // Get alerts when your favourite items go on sale
    desc_2: gettextNoop("member_signup_small_banner.alerts_sale.description"),
    // Save searches on your favourite items
    desc_3: gettextNoop("member_signup_small_banner.searches.description"),
};

export function EmailSignupBanner({
    openCustomerCaptureOverlay,
    onClose,
}: EmailSignupBannerProps): JSX.Element {
    // "Sign Up"
    let ctaText = gettext("member_signup_small_banner.general.cta");
    // "Become a Lyst Member"
    const bannerTitle = gettext("member_signup_small_banner.become_member.title");
    const descriptionVariant = String(
        environment.getFeature("mg_android_email_signup_banner_desc")
    );
    let bannerDescription = gettext(DESC_KEYS[descriptionVariant]);
    const analyticsEventCategory = "email_banner";

    function getPageSource(): string {
        const pageType = environment.get("pageType");
        const pageSubType = environment.get("pageSubType");
        let pageSource = "feed";
        if (pageType == "product" && pageSubType == "in_stock") {
            pageSource = "pdp";
        } else if (pageType == "product" && pageSubType == "oos") {
            pageSource = "oos";
        }
        return pageSource;
    }

    function onClick(): void {
        const pageSource = getPageSource();
        analytics.event(
            analyticsEventCategory,
            "open_signup_form",
            `${pageSource}-${descriptionVariant}`
        );

        openCustomerCaptureOverlay({
            captureType: "signup_banner",
        });
    }

    return (
        <>
            <div className={styles.placeholder} />
            <div className={classnames(styles.sticky, styles.downloadBanner)}>
                <div className={styles.wrapper}>
                    <CloseButton className={styles.closeButton} onClick={onClose} />
                    <div className={classnames(styles.content)}>
                        <div className={styles.title}>{bannerTitle}</div>
                        <div className={styles.description}>{bannerDescription}</div>
                    </div>
                    <div className={styles.ctaContainer}>
                        <PrimaryButton
                            onClick={onClick}
                            styleType="cta"
                            disabled={false}
                            fullWidth={true}
                            fullHeight={false}
                            openInNewTab={false}
                            className={styles.cta}
                            aria-label={ctaText}
                        >
                            {ctaText}
                        </PrimaryButton>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withReduxProvider(connect(null, { openCustomerCaptureOverlay })(EmailSignupBanner));
